module.exports = __webpack_public_path__ + "assets/b76.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b76.png
// module id = 667
// module chunks = 0